<style scoped>  

  @media only screen and (max-width: 360px) {
    .search-input {
      max-width: 80% !important;
    }
  }

  @media only screen and (min-width: 361px) {
    .search-input {
      max-width: 85% !important;
    }
  }

  .action-button {
    min-width: 130px;
  }

</style>

<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="ten wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button action-button" @click="$refs.formModal.create()">
          <i class="plus icon"></i> Novo Título
        </button>
        <router-link class="ui green button action-button m-l-10" to="/financial/receivables-settles">
          <i class="check square outline icon"></i> Baixas
        </router-link>
        <div id="easy-access-button" class="ui black floating dropdown button action-button m-l-10">
          <i class="magic icon"></i> Acesso rápido
          <div class="menu">
            <div class="item" @click="onSetQuickFilter('expired')">Vencidos</div>
            <div class="item" @click="onSetQuickFilter('expiring_today')">Vencendo hoje</div>
            <div class="item" @click="onSetQuickFilter('expiring_this_week')">Vencendo essa semana</div>
          </div>
        </div>
      </div>
      <div class="six wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="receivables-search-input" ref="searchInput" class="search-input" @onSearch="search" />
              <button class="ui icon button m-l-10" @click="$refs.filterModal.show()">
                <i class="filter icon" :class="{ red: !!$store.state.pages.filters.receivables }"></i>
              </button>
            </div>
          </div>                        
        </div> 
      </div>      
    </div>

    <data-table id="receivables-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" 
      sortBy="id" :asc="false" :danger="isExpired" @onRowClick="onShowReceivable" />

    <filter-modal ref="filterModal" @onApply="filter" @onRemove="clearFilter" />

    <form-modal ref="formModal" @onSave="refresh()" @onRemove="$refresh()" />

  </div>

</template>

<script>
  
  import moment from "moment"
  import FilterModal from "./filter"  
  import FormModal from "./form-modal"
  import ReceivableService from "@/services/receivable-service"
  import { gridPage, onlyFinancial } from "@/mixins"

  export default {    

    name: "ReceivablesPage",

    mixins: [gridPage, onlyFinancial],

    data() {
      return {       
        title: "Títulos a Receber", 
        service: new ReceivableService(),
        attributes: ["id", "type", "date", "dueDate", "realDueDate", "value", "balance"],
        fields: [          
          { prop: "id", label: "Número", render: this.renderNumber },
          { prop: "type", label: "Tipo", render: this.renderType },
          { prop: "customer.shortName", model: "Customer", label: "Cliente" },
          { prop: "date", label: "Emissão", render: (receivable) => this.$formatDate(receivable.date) },
          { prop: "dueDate", label: "Vencimento", render: (receivable) => this.$formatDate(receivable.dueDate) },
          { prop: "realDueDate", label: "Venc. Real", render: (receivable) => this.$formatDate(receivable.realDueDate) },
          { prop: "value", label: "Valor", render: (receivable) => "R$ " + this.$formatCurrency(receivable.value) },
          { prop: "balance", label: "Saldo", render: (receivable) => "R$ " + this.$formatCurrency(receivable.balance) },
          { prop: "settles", label: "Baixas", render: this.renderSettles },
        ],
      }
    },

    components: {
      FilterModal,
      FormModal,
    },

    mounted() {
      $("#easy-access-button").dropdown()
    },

    methods: {

      onSetQuickFilter(option) {

        this.$refs.dtbl.setLoading(true)
        
        const filter = this.$refs.filterModal.setQuickFilter(option)
                
        this.filter(filter)
      },

      isExpired(receivable)  {
        return receivable.isExpired
      },

      renderNumber(receivable) {
        return `<i class="${receivable.statusData.icon} m-r-10"></i> ${receivable.id}` 
      },

      renderType(receivable) {
        return receivable.typeData.label
      },

      renderSettles(receivable) {

        let html = ""

        if (!receivable.settles.length)
          return ""

        html += `<div class="ui small labels">`
        
        for (const settle of receivable.settles) {

          html += `<div class="ui small label">R$ ${this.$formatCurrency(settle.value)}`
          
          if (settle.employee)
            html += `<div class="detail">${settle.employee.name}</div>`
          
          html += `</div>`
        }

        html += `</div>`  

        return html
      },

      onShowReceivable(data) {
        this.$router.push(`/financial/receivables/${data.row.id}`)
      },
    },
  }

</script>